export const Team = [
  {
    name: `Ken Branton`, 
    url: `ken-branton`,
    profession: `Creative Director`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-ken-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-jordan-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Ian Tremblay`, 
    url: `ian-tremblay`,
    profession: `Art Director`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-ian-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-cailey-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Jay Sheppard`, 
    url: `jay-sheppard`,
    profession: `Production Manager`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-jay-off.jpg`), 
    previewSecondary: require(`@/assets/images/juliana_off.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Rodney Hagle`, 
    url: `rodney-hagle`,
    profession: `Full Stack Developer and UX Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-rodney-off.jpg`), 
    previewSecondary: require(`@/assets/images/juliana_off.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Taylor Harrison`, 
    url: `Taylor`,
    profession: `French Translation Project Manager`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-taylor-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-taylor-off.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Crystal-Ann Roy`, 
    url: `crystalann`,
    profession: `Billing and Administration`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`,), 
    active: false,
    silhouette: true
  },
  {
    name: `Nadine`, 
    url: `nadine`,
    profession: `French Translation Team Lead`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-nadine-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-jordan-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Félicia Caskanette`, 
    url: `felicia-caskanette`,
    profession: `Senior French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-felicia-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-jordan-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Brock Metcalfe`, 
    url: `brock-metcalfe`,
    profession: `Senior Graphic Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-brock-off.jpg`), 
    previewSecondary: require(`@/assets/images/juliana_off.jpg`,), 
    active: false,
    silhouette: false
  },

  {
    name: `Joe Kormendi`, 
    url: `joe-kormendi`,
    profession: `Digital Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-joe-off.jpg`), 
    previewSecondary: require(`@/assets/images/juliana_off.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Ryan Gaudet`, 
    url: `ryan-gaudet`,
    profession: `Senior Graphic Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-ryang-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-ryan-g-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Jordan Brick`, 
    url: `jordan-brick`,
    profession: `Senior Graphic Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-jordan-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-jordan-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Carly Krause`, 
    url: `carly-krause`,
    profession: `Senior Graphic Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-carly-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-jordan-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Sarah Lilley`, 
    url: `sarah-lilley`,
    profession: `Senior Graphic Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-sarah-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-jordan-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Julie Barrow`, 
    url: `julie-barrow`,
    profession: `Graphic Designer`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-julie-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-cailey-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Kate Stewart`, 
    url: `kate`,
    profession: `Creative Copywriter`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`,), 
    active: false,
    silhouette: true
  },
  {
    name: `Anna Syska`, 
    url: `anna-syska`,
    profession: `Senior French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-anna-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-cailey-on.jpg`,), 
    active: false,
    silhouette: false
  },
  {
    name: `Andrea Blake`, 
    url: `andrea`,
    profession: `Senior French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-andrea-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-cailey-on.jpg`,), 
    active: false,
    silhouette: false
  },

  {
    name: `Ester Tureckova`, 
    url: `ester`,
    profession: `Senior French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`,), 
    active: false,
    silhouette: true
  },


  {
    name: `Barbara Amberg`, 
    url: `barbara`,
    profession: `French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-barabara-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`,), 
    active: false,
    silhouette: true
  },

  {
    name: `Emilie Gariepy`, 
    url: `emilie`,
    profession: `French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`,), 
    active: false,
    silhouette: true
  },
  {
    name: `Sarah Loureiro`, 
    url: `sarah`,
    profession: `French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-sarahl-off.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`,), 
    active: false,
    silhouette: true
  },
  {
    name: `Eleanor Wong`, 
    url: `eleanor`,
    profession: `French Translator`, 
    preview: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`), 
    previewSecondary: require(`@/assets/images/team-members/thumbnails/thumb-fm-silouette.jpg`,), 
    active: false,
    silhouette: true
  },
]